import axios from 'axios';
import Cookies from 'js-cookie';

import { MDBCountdown, MDBCountdownUnit } from 'mdb-react-countdown';
import {
    MDBAlert,
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBCol,
    MDBContainer,
    MDBInput,
    MDBPopconfirm,
    MDBPopconfirmMessage
} from "mdb-react-ui-kit";
import PropTypes from 'prop-types';
import React, { useContext, useState ,useEffect} from "react";
import { useNavigate } from 'react-router-dom';
import { handlePasswordValidation, PasswordAlertCard, validatePassword } from './../utils/Common';
import useLogout from './UseLogout';
import { MiscContext } from '../context/MiscProvider';
import { UserProfileContext } from '../context/UserProfileProvider';
const ForgotPassword = ({ showLoginModal,  existingUser,countDown, setCountDown, setIsForgotPassword, setIsForgotUserId}) => {
    const logout = useLogout();
    const [alertColor, setAlertColor] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [regex, setRegex] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState('');
    const navigate = useNavigate();
    const { forgotPasswordModalOpen,  setForgotPasswordModalOpen,alertMessage, setAlertMessage,showAlert, setShowAlert,setPwdAlert } = useContext(MiscContext);
    const {tokenLoaded} = useContext(UserProfileContext);
    const baseUrl = process.env.REACT_APP_INVENTORY_URL;
    const authUrl = process.env.REACT_APP_AUTH_URL;

    const handlePassword = (event) => {
        event.preventDefault();
        handlePasswordValidation(event, newPassword, confirmPassword, setAlertMessage, setAlertColor, setShowAlert);
        setRegex(validatePassword(newPassword));
        if (newPassword !== confirmPassword || !regex) {
           return; // Prevent form submission if password validation fails
        }
    };
    const generateUniqueId = (baseId) => `${baseId}-${Math.random().toString(36).slice(2, 9)}`;
    const loginPasswordId = generateUniqueId('loginPassword');
    const newPasswordId = generateUniqueId('new-passwordInP');
    const confirmNewPasswordId = generateUniqueId('new-confirm-passwordInP');
    const registerFirstNameId = generateUniqueId('registerFirstName');
    const registerPasswordId = generateUniqueId('registerPassword1');
    const registerRepeatPasswordId = generateUniqueId('registerRepeatPasswod1');
  
    const updatePassword = async () => {
        setPwdAlert(false)
        if (!regex) {
            return;
        }
     // Remove existing TOTP cookie
     Cookies.remove('TOTP');
        // Fetch TOTP cookie before making the request
        const totpCookie = Cookies.get('TOTP');
    
        // Include the TOTP cookie in the request headers
        const headers = {
            'Content-Type': 'application/json'        };
    
        // If TOTP cookie exists, include it in the headers
        if (totpCookie) {
            headers['Cookie'] = `TOTP=${totpCookie}`;
        }
    
        // Make the Axios PUT request with the updated headers
        try {
            if(newPassword !== confirmPassword){
                setAlertMessage('password and repeated password do not match');
                setAlertColor('black');
                setShowAlert(true);
                setTimeout(() => setShowAlert(false), 5000);
                return;
            }
            const response = await axios.put(
                `${authUrl}/users/pwd/${newPassword}/rePwd/${confirmPassword}`,
                { /* request body if needed */ },
                { headers }
            );
    
            // Handle the response as before
            if (response.status === 200) {
                setAlertMessage(response.data.userMessage);
                setAlertColor('success');
                setShowAlert(true);
                setTimeout(() => setShowAlert(false), 5000);
                logout();       
               
            } else if (response.status === 422) {
                setAlertMessage('Password has been updated');
                setAlertColor('success');
                setShowAlert(true);
                setTimeout(() => setShowAlert(false), 5000);
                logout(); 
            }
            setShowAlert(true);
            setCountDown(0);
            setIsForgotUserId(false);
            setIsForgotPassword(false);
            setForgotPasswordModalOpen(false);
        } catch (error) {
            console.error(error);
        }
    };
    
    const handleApply = async () => { 
        const user = { password: newPassword, confirmPassword: confirmPassword, ou: existingUser.firmId, uid: existingUser.uid };
if(!regex){
    return;
}
        axios.put(`${baseUrl}/userprofiles`,  {...user, ou: existingUser.firmId, uid: existingUser.uid})
            .then(async response => { 
                if (response.status === 200) {
                    setAlertMessage('Password has been updated');
                    setAlertColor('success');
                    setShowAlert(true);
                    setTimeout(() => setShowAlert(false), 5000);
                    logout(); 
                }
                 if (response.status === 422) {
                    setAlertMessage('Password has been updated');
                    setAlertColor('success');
                    setShowAlert(true);
                    setTimeout(() => setShowAlert(false), 5000);
                    logout(); 
                }
                setForgotPasswordModalOpen(false);
               
            })
            .catch(error => {
                console.error(error);
            });
    };
    const allFieldsEntered = newPassword.trim() !== '' && confirmPassword.trim() !== '';
    const now = new Date();
    const endTime = new Date(now.getTime() + countDown * 60000);
   
    return (
        <MDBCol className='text-center rounded mt-3 gy-2 gx-3 align-items-center' style={{ marginBottom: '20px' }}>
            
             <h5 className="display-8 fw-bold text-uppercase text-black mb-0 text-center" style={{ letterSpacing: '5px' }}>password  </h5>
           
             {!tokenLoaded &&    <MDBCountdown countdown={endTime} position='horizontal' >
          <div className="d-flex  justify-content-center align-items-center gap-3 mb-2" >
  <MDBCountdownUnit label=' mins' type='minutes' />
  <MDBCountdownUnit label=' secs' type='seconds' />
  </div>
</MDBCountdown>}

               
              
                    
            <MDBCard className='text-center rounded  gy-2 gx-3 align-items-center'>
            {(newPassword.trim() !== confirmPassword.trim()) && <PasswordAlertCard/>}
                <MDBCardBody className="text-center">
           
                    <form onSubmit={handlePassword}>
                        <MDBInput className="mb-4" id={newPasswordId} label="New password *" type='password' onChange={(e) => {setNewPassword(e.target.value);setPwdAlert(true)}} required/>
                        <MDBInput className="mb-4" id={confirmNewPasswordId} label="Confirm password *" type='password' onChange={(e) => setConfirmPassword(e.target.value)} required/>
                        <div className="d-grid gap-2 d-md-block">
                        <MDBPopconfirm   disabled={!allFieldsEntered || newPassword.trim() !== confirmPassword.trim() ||  !validatePassword(newPassword.trim()) || !validatePassword(confirmPassword.trim())}  
                            modal
                            btnChildren="APPLY"
                            onConfirm={existingUser ? handleApply : updatePassword}
                            onCancel={() => { }}
                            cancelBtnText={regex ? 'Cancel'  : null}
                            //cancelBtnClasses={showAlert ? 'd-none' : ''}
                            cancelBtnClasses={`btn-warning ${regex ? ''  : 'd-none'}`}
                            confirmBtnClasses={`btn-primary `}
                        >
                            <MDBPopconfirmMessage><span className='text-primary' dangerouslySetInnerHTML={{ __html: alertMessage }} /> </MDBPopconfirmMessage>
                            
                        </MDBPopconfirm>
                       {forgotPasswordModalOpen &&  <MDBBtn className='mx-2' color='danger'  onClick={() => setForgotPasswordModalOpen(false)}>close</MDBBtn>}
                        </div>
                    
                    </form>
                    
                </MDBCardBody>

                <MDBAlert open={showAlert}
                    color='warning'
                    autohide ={true}
                    delay={60000}
                    onClose={() => setShowAlert(false)} 
                >
                   <i className='fas fa-check-circle me-3'></i>  {alertMessage} <MDBBtn className='btn-close ms-3' onClose={()=> setShowAlert(false)}></MDBBtn>
                </MDBAlert>
                
            </MDBCard>
             
        </MDBCol>
    );
};
ForgotPassword.propTypes = {
    showLoginModal: PropTypes.func,   
    existingUser: PropTypes.object,
    countDown: PropTypes.number,
    setCountDown: PropTypes.func,
    setIsForgotPassword: PropTypes.func,
    setIsForgotUserId: PropTypes.func,
}

export default ForgotPassword;
